export default __webpack_public_path__ + "static/media/homePage.c4b33a49.jpg";